import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import RoomAddForm from "./RoomAddForm";


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));


const RoomAdd = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <RoomAddForm history={history} />
      </div>
    </div>
  );
};


RoomAdd.propTypes = {
  history: PropTypes.object
};

export default RoomAdd;
